var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exp_it" }, [
    _c(
      "div",
      { staticClass: "panel", attrs: { id: "panel-4" } },
      [
        _c("div", { staticClass: "panel-hdr" }, [
          _c("h2", [
            _vm._v("\n                " + _vm._s(_vm.__t("LIST")) + " "),
            _c("span", { staticClass: "fw-300" }, [
              _c("i", [_vm._v(_vm._s(_vm.__t("ORDERS")))]),
            ]),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "panel-container show" }, [
          _c(
            "div",
            { staticClass: "panel-content" },
            [
              _c("date-picker", {
                attrs: {
                  "value-type": "format",
                  lang: _vm.d_lang,
                  range: "",
                  "first-day-of-week": 1,
                  shortcuts: _vm.shortcuts,
                  confirm: "",
                },
                model: {
                  value: _vm.time_range,
                  callback: function ($$v) {
                    _vm.time_range = $$v
                  },
                  expression: "time_range",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("b-overlay", { attrs: { show: _vm.loading } }, [
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary waves-effect waves-themed",
                attrs: { type: "button" },
                on: { click: _vm.export_it },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.__t("EXPORT")) +
                    "\n            "
                ),
              ]
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-toolbar" }, [
      _c("button", {
        staticClass: "btn btn-panel waves-effect waves-themed",
        attrs: {
          "data-action": "panel-fullscreen",
          "data-toggle": "tooltip",
          "data-offset": "0,10",
          "data-original-title": "Fullscreen",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }